import React, { useState, useEffect } from 'react';
import Donateform from '../components/Donateform';
import { useLocation } from 'react-router-dom';
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet';

function Donate() {
  const [selectedFrequency, setSelectedFrequency] = useState('');
  const [selectedAmount, setSelectedAmount] = useState('');
  const [customAmount, setCustomAmount] = useState('');
  const [cardNumber, setCardNumber] = useState('');
  const [expiryMonth, setExpiryMonth] = useState('');
  const [expiryYear, setExpiryYear] = useState('');
  const [cvv, setCvv] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const location = useLocation();
  const userId = localStorage.getItem('userid');

  useEffect(()=>{
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: 'Dashboard Donate Page' });
  }, []);
  const validateForm = () => {
    // Ensure that either a preset amount is selected or a custom amount is entered.
    const amount = selectedAmount === 'custom' ? customAmount : selectedAmount;
    if (!selectedFrequency || (!selectedAmount && !customAmount) || !cardNumber || !expiryMonth || !expiryYear || !cvv) {
      setErrorMessage('Please fill all fields.');
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleFrequencySelect = (frequency) => {
    setSelectedFrequency(frequency);
  };

  const handleAmountSelect = (amount) => {
    setSelectedAmount(amount);
    // If a preset amount is selected, clear the custom amount.
    if (amount !== 'custom') {
      setCustomAmount('');
    }
  };


  const handleCustomAmountChange = (event) => {
    const value = event.target.value;
    // Directly set custom amount from the event, and ensure 'custom' is selected.
    setCustomAmount(value);
    setSelectedAmount('custom');
  };


const handleNumericChange = (event, setter) => {
  const value = event.target.value;
  if (/^\d*$/.test(value)) { // Allows only numbers or an empty string
    setter(value);
  }
};

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) {
      return; // Prevent form submission if validation fails
    }
    // Parse the amount to ensure it's a number
    const parsedAmount = selectedAmount === 'custom' ? parseFloat(customAmount) : parseFloat(selectedAmount.replace('$', ''));
    // Construct the payload
    const payload = {
      creditCard: cardNumber,
      cardCVV: cvv,
      cardExpiryDate: `${expiryYear}-${expiryMonth}`,
      amount: isNaN(parsedAmount) ? 0 : parsedAmount,
      currencyCode: "USD",
      frequency: selectedFrequency,
    };

    console.log(payload);

    // Example: POST request to the server
    // Replace with actual API call
    /*
    fetch('http://localhost:3000/donate/makePayment', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => console.log(data))
      .catch(error => console.error('Error:', error));
    */
  };

  // Utility function to dynamically apply selection styles
  const isSelected = (value) => {
    return selectedFrequency === value || selectedAmount === value ? 'selected' : '';
  };

  return (
    <div className="layout-wrapper layout-content-navbar">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Donate</title>
      </Helmet>
      <div className="layout-container">
        <Donateform userId={userId} />
      </div>
    </div>
  );
}

export default Donate;
